module.exports = __webpack_public_path__ + "img/myguard_about_05.41435f89.png";